import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './vuex/store'
// import store from './vuex/store'
// import {Message} from 'element-ui'
Vue.use(VueRouter)
import Login from './view/loginAndHome/login/login'
import changePaw from './view/loginAndHome/login/changePaw'
import Home from './view/loginAndHome/home/home'
import GIS from './view/timeGIS/timeGis.vue'
import cloudPicture from './view/cloud-picture/cloud-picture'

// import SystemIndex from './view/systemManage/system-index'
import systemManage from './view/systemManage/system-index'
import test from './router/test'
import systemSetup from './router/giveOrders'
import command from './router/command-center'
import assitance from './router/social-assitance.js'
import mediaRelease from './router/media-release.js'
import visualIntercom from './router/visualIntercom'
import visitsCircle from './router/visits-circle.js'
import xlSastics from './router/xl-sas.js'
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [
    {
        path: '/',
        redirect: '/login',
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            title: '登录'
        }
    },
    {
        path: '/changePaw',
        name: 'changePaw',
        component: changePaw,
        meta: {
            title: '忘记密码'
        }
    },
    {
        path: '/GIS',
        name: 'GIS',
        component: GIS,
        meta: {
            title: '时空地图'
        }
    },
    {
        path: '/cloud-picture',
        name: 'cloud-picture',
        component: cloudPicture,
        meta: {
            title: '云图分析'
        }
    },

    {
        path: '/index',
        name: 'index',
        redirect: '/test',
        component: systemManage,
        children: [
            test,
            systemSetup,
            visualIntercom,
            command,
            assitance,
            mediaRelease,
            visitsCircle,
            xlSastics,
            {
              path: '/home',
              name: 'home',
              component: Home,
              meta: {
                title: '首页'
              }
            },
        ]
    },
]

const router = new VueRouter({
    base: process.env.BASE_URL,
    routes: routes
})
const whiteList = ['/changePaw','/login','/tree']//不重定向白名单
Array.prototype.xeach = function (fn, ak, nowPath, parentNode) {
    try {
      this.i || (this.i = 0);
      if (this.length > 0 && fn.constructor == Function) {
        while (this.i < this.length) {
          const item = this[this.i];
          const e = this[this.i].sourceTreeDTOList;
          if (e && e.constructor == Array && !this[this.i].isButton) {
            if (this.i == 0) {
              ak++;
            }
            if (ak == 1) {
              parentNode = item;
            }
            if (item.code == nowPath) {
              fn(parentNode);
              parentNode = "";
              break;
            } else {
              e.xeach(fn, ak, nowPath, parentNode);
            }
          } else {
            // fn.call(e, e, e);
          }
          this.i++;
        }
      }
      this.i = null;
    } catch (ex) {}
    // return this;
  };
router.beforeEach((to, form, next) => {
	if(to.path=='/home'){
		store.commit('setIsHome',true);
	}else{
		store.commit('setIsHome',false);
	}
    if(to.path === '/login') {
        if(localStorage.getItem('a')&&localStorage.getItem('token')) {
            // let m=JSON.parse(JSON.parse(crypto.decrypt(localStorage.getItem('m'))));
            // let resourceUrls= m.filter((ietm=>{return ietm.selected==true;}));
            // let arr=[{name:resourceUrls[0].title,path:resourceUrls[0].resourceUrl}];
            let  userId =JSON.parse(localStorage.getItem('ur')).id
            sessionStorage.setItem('userId',userId)
            next({ path:'/home'})
            return
        }else{
			next()
		}
    }else{
		if (whiteList.includes(to.path)) {
			next()
		} else {
			if(localStorage.getItem('token')){
                let newPath = "";
                const sourceTreeDTOList = store.state.configMenuList ? store.state.configMenuList : [];
                sourceTreeDTOList.xeach(
                    function (data) {
                        newPath = data.code;
                    },
                    0,
                    to.path
                );
                store.commit("SET_HEADACTIVEINDEX", newPath);
                store.commit("SET_LEFTACTIVEINDEX", to.path);

				next()
			}else{
				next('/login')
			}
			// NProgress.done()
		}
	}

})

router.afterEach(to => {
    if(to.path !== '/login') {
        document.title = to.meta.title
        // store.commit('addBreadcrumb', {name: to.meta.title, path: to.path, level: to.meta.level})
        // sessionStorage.setItem('br', JSON.stringify(store.state.breadcrumbData))
    }
})
export default router
